import Main from "@/components/main";
import parentView from "@/components/parent-view";

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面不会缓存
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  {
    path: "/",
    name: "_home",
    redirect: "/home",
    meta: { hide: true },
    component: Main,
    children: [
      {
        path: "/home",
        name: "home",
        meta: { title: "概况", notCache: true, icon: "md-home" },
        component: () => import("@/view/home")
      }
    ]
  },
  {
    path: "/construction",
    name: "construction",
    meta: { hide: true },
    component: Main,
    children: [
      {
        path: "/construction/department",
        name: "department",
        meta: { icon: "md-podium", title: "部门管理", notCache: true },
        component: () => import("@/view/department")
      },
    ]
  },
  {
    path: "/department",
    name: "department",
    meta: { hide: true },
    component: Main,
    children: [
      {
        path: "/department/staff",
        name: "staff",
        meta: { icon: "md-people", title: "员工管理", notCache: true },
        component: () => import("@/view/department/staff")
      }
    ]
  },
  {
    path: "/project",
    name: "project",
    meta: { hide: true },
    component: Main,
    children: [
      {
        path: "/project_manage",
        name: "project_manage",
        meta: { icon: "md-apps", title: "项目管理", notCache: true },
        component: () => import("@/view/project_manage")
      }
    ]
  },
  {
    path: "/machine",
    name: "machine",
    meta: { title: "设备管理", icon: "md-menu" },
    component: Main,
    children: [
      {
        path: "/machine/status",
        name: "machine_status",
        meta: { icon: "md-print", title: "设备状态"},
        component: () => import("@/view/machine")
      },
      {
        path: "/machine/fault",
        name: "machine_fault",
        meta: { icon: "md-close-circle", title: "故障记录"},
        component: () => import("@/view/machine/fault")
      },
    ]
  },
  {
    path: "/data",
    name: "data",
    meta: { title: "印量报表", icon: "md-disc" },
    component: Main,
    children: [
      {
        path: "/data/print",
        name: "print",
        meta: { title: "印量查询", icon: "md-filing" },
        component: () => import("@/view/data_print")
      },
      {
        path: "/data/record",
        name: "record",
        meta: { title: "作业记录", icon: "md-list" },
        component: () => import("@/view/data_record")
      },
      {
        path: "/data/chart",
        name: "chart",
        meta: { title: "图形板", icon: "md-grid", access: ["company_admin"] },
        component: () => import("@/components/parent-view"),
        children: [
          {
            path: "/data/chart/amount",
            name: "amount",
            meta: { title: "数据排名", icon: "md-reorder" },
            component: () => import("@/view/data_amount")
          },
          {
            path: "/data/chart/trend",
            name: "trend",
            meta: { title: "数据走势", icon: "md-trending-up" },
            component: () => import("@/view/data_trend")
          },
          {
            path: "/data/chart/operate",
            name: "operate",
            meta: { title: "操作占比", icon: "md-pie" },
            component: () => import("@/view/data_pie")
          }
        ]
      },
      // {path: '/data',name: 'data',meta: {icon: 'md-trending-up',title: '综合查询',notCache: true},component: () => import('@/view/data')},
    ]
  },
  {
    path: "/finance",
    name: "finance",
    meta: { icon: "logo-usd", title: "财务管理", hide: true },
    component: Main,
    children: [
      {
        path: "/finance/recharge_staff",
        name: "recharge_staff",
        meta: { icon: "md-cash", title: "员工充值", notCache: true },
        component: () => import("@/view/recharge_staff")
      },
      {
        path: "/finance/recharge_company",
        name: "recharge_company",
        meta: {
          icon: "ios-globe",
          title: "企业充值",
          notCache: true
        },
        component: () => import("@/view/recharge_company")
      },
      {
        path:"finance/recharge_apply",
        name:"recharge_apply",
        meta: {
          icon: "md-information-circle",
          title: "充值受理",
          notCache: true
        },
        component: () => import("@/view/recharge_apply")
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    meta: { title: "Login - 登录", hideInMenu: true },
    component: () => import("@/view/login/login.vue")
  },
  // 401
  {
    path: "/401",
    name: "error_401",
    meta: { hideInMenu: true },
    component: () => import("@/view/error-page/401.vue")
  },
  {
    path: "/user_center",
    name: "_user_center",
    meta: { hideInMenu: true },
    component: Main,
    children: [
      {
        path: "/user_center",
        name: "user_center",
        meta: { title: "个人中心",hide: true },
        component: () => import("@/view/user_center")
      }
    ]
  },
];
// {path: '/goods',name: 'goods',meta: {title: '商品',icon: 'md-cart'},component: Main,children: [
